import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from "../../features/userSlice";
import Select, { components } from 'react-select';
import axios from 'axios';
import styles from './RegenerateMuster.module.css'; // Import CSS module

// Custom Option component to include checkboxes in the dropdown
const CustomOption = (props) => {
  const { innerRef, innerProps, isSelected, data } = props;
  return (
    <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
      <input type="checkbox" checked={isSelected} onChange={() => null} />
      <label style={{ marginLeft: 8 }}>{data.label}</label>
    </div>
  );
};

const ManualProcessAttendance = () => {
  const [employeeCode, setEmployeeCode] = useState('');
  const [contractor, setContractor] = useState([]);
  const [billingCycle, setBillingCycle] = useState([]);
  const [pmonth, setPmonth] = useState([]);
  const [entity, setEntity] = useState([]);
  const [selectedContractor, setSelectedContractor] = useState([]);
  const [selectedBillingCycle, setSelectedBillingCycle] = useState(null);
  const [selectedPmonth, setSelectedPmonth] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({}); // State for validation errors
  const navigate = useNavigate();

  const user = useSelector(selectUser);
  const token = user?.token;

  const handleProcess = async () => {
    // Basic validation to check if all required inputs are provided
    setLoading(true); // Start loading
    try {
      const data = {
        contractorFilter: "",
        billingtype: "",
        entityFilter: "",
        pmonth: "",
        employeeCode: "'",
      };

      //const response = await axios.post('/api/attendance/manualProcessAttendance',data);
      const response = await axios.post('/api/attendance/triggerTask',{taskName:'process_biometric'});
      const response1 = await axios.post('/api/attendance/triggerTask',{taskName:'ProcessPunchMark'});
      alert('Manual Process of Attendance Data is Job Submitted, check aftre 5 mins!');
    } catch (error) {
      console.error('Error regenerating Muster:', error);
      alert('Failed to regenerate muster. Please try again.');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div>
      <div><br></br></div>
      <div className={styles.container}>
        <h2 className={styles.heading}>Daily Attendance Utility - Schedule Job</h2>
        <form>
          {/* Submit Button */}
            <br></br>
            <br></br>
            <br></br>
            <div className={styles.container} style={{ textAlign: 'center' }}>
            Do not process multiple instances
            </div>
            <br></br>
            <br></br>
            <br></br>
          <div className={styles.buttonContainer}>
            <button type="button" className={styles.button} onClick={handleProcess}>
              Process Attendance
            </button>
          </div>
          <br></br>
          <br></br>
          {/* Loading Spinner */}
          {loading && (
            <div className={styles.loaderContainer}>
              <div className={styles.spinner}></div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ManualProcessAttendance;
